import { CustomDateFormatPipe } from '../../../../../_helpers/_pipes/custom-date-format.pipe';
import { ImpNoticeComponent } from '../../imp-notice/imp-notice.component';
import { BnImpNoticeComponent } from '../../billing-new/bn-notice/bn-imp-notice/bn-imp-notice.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { MapfreDesignLibraryModule } from '../../../../../modules/mapfre-design-library/src/public_api';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, OnInit, Input } from '@angular/core';
import { AcmicService } from '@mapfre-design-library/src/public_api';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, MapfreDesignLibraryModule, NgSelectModule, BnImpNoticeComponent, ImpNoticeComponent, CustomDateFormatPipe],
  selector: 'app-payment-alert',
  templateUrl: './payment-alert.component.html',
  styleUrls: ['./payment-alert.component.scss'],
})
export class PaymentAlertComponent implements OnInit {
  @Input() policy: any;
  @Input() guest: boolean;
  autoPayDate: string;
  isAutoPay: boolean;
  autoPayForce: boolean;
  autoPayAlert: boolean;
  isAcmic: boolean;
  paymentMessage: boolean;
  deductionDay: string;
  paymentInfo: string;
  // TEMP: suppress "Automatic payment scheduled" messaging until upcoming-bill autopay coverage can be confirmed; flip to false to restore
  suppressAutoPayAlertNotice = true;

  constructor(private acmicService: AcmicService) {}

  ngOnInit(): void {
    this.isAcmic = this.acmicService.isACMIC();
    this.getAutoPayDate();
    this.paymentInfo =
      `Payments will be applied to any prior remaining term balance first.
       The current amount due and any prior balances are shown on the dashboard under “Current Amt Min Due”.`;
  }

  getAutoPayDate() {
    this.autoPayDate =
      this.policy.billingDetails[0] &&
      this.policy.billingDetails[0].paymentDueDate
        ? this.policy.billingDetails[0].paymentDueDate
        : '';
    this.calculateAutoPayDate();
  }

  calculateAutoPayDate() {
    if (this.policy.autoPayDetails && this.policy.autoPayDetails.dateMS) {
      const date =
        this.policy.autoPayDetails.dateMS / 86400000 - Date.now() / 86400000;
      this.autoPayForce = date >= 0 && date <= 2.99;
      this.autoPayAlert = date >= 3 && date <= 15;
      this.paymentMessage = this.autoPayForce || this.autoPayAlert;
      this.deductionDay = this.policy.autoPayDetails.deductionDay;
    }
  }
}
